import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

import MainModal from "./MainModal";

import 'swiper/swiper.min.css'
import 'swiper/css/navigation'
import "../../styles/search/detail/job-details.css";
import "../../"

const ShowPhotosModal = props => {
    const getBackgroundImage = (media) => {
        var arr = media.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        let image =  new File([u8arr], media.fileName, { type: mime })
       return URL.createObjectURL(image)
    }
    return (
        <MainModal
            style={{ height: "750px", width: "1000px" }}
            title={props.title}
            subtitle={""}
            isVisible={props.isVisible}
            onClose={props.onClose}
            className="evidenceImagesModal"
        >
            {props.photos ? (
                <Swiper navigation={true} modules={[Navigation]} className="evidenceSwiper">
                    {props.photos.map((media, index) => {
                        const isVideo = Boolean(typeof media.fileName === "string" && media.fileName.match(/\.(mp4|webm|ogg)$/i));
                        return isVideo ? (
                            <SwiperSlide key={media.fileName} className="evidenceSlideImage" >
                                <video key={index} className="fixedPhotos-video" controls>
                                    <source src={media.base64} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </SwiperSlide>

                        ) : (
                            <SwiperSlide key={media.filename} className="evidenceSlideImage" >
                                <div style={{ backgroundImage: media.base64 ? "url("+ getBackgroundImage(media.base64)+")" : media }}></div>
                            </SwiperSlide>
                        );
                    })
                    }
                </Swiper>) : null}

            <div className="show-photos-modal-wrapper">
                {

                }
            </div>
        </MainModal>
    )
}

export default ShowPhotosModal;